<template>
    <div>
        <div>{{ option.text }}</div>
        <small v-if="option.catalog_name" class="d-block text-muted">
            Группа: {{ option.catalog_name }}
        </small>
        <small v-if="option.inventory_number" class="d-block text-muted">
            Инв.: {{ option.inventory_number }}
        </small>
        <div class="mt-1">
            <b-badge
                v-if="statusText"
                :variant="statusVariant"
                class="mr-1"
            >
                {{ statusText }}
            </b-badge>
            <b-badge
                v-if="isQuantity"
                variant="info"
                class="mr-1"
            >
                Количественная
            </b-badge>
        </div>
        <small v-if="option.assignment_details" class="d-block text-muted">
            {{ option.assignment_details }}
        </small>
        <small v-if="isQuantity" class="d-block text-muted">
            Доступно: {{ availableText }} {{ option.unit_of_measurement }}
        </small>
    </div>
</template>

<script>
export default {
  name: 'MechanicAssetOptionPreview',
  props: {
    option: {
      type: Object,
      required: true
    },
    statusText: {
      type: String,
      default: ''
    },
    statusVariant: {
      type: String,
      default: 'secondary'
    }
  },
  computed: {
    isQuantity() {
      return this.option.accounting_type === 'quantity';
    },
    availableText() {
      const value = this.option.available_quantity || 0;
      return parseFloat(value).toFixed(3).replace(/\.?0+$/, '');
    }
  }
};
</script>
